import { isNumber, map } from 'lodash';
import { useCallback } from 'react';

import { PayoutRequisitesAutomation } from 'types';

import { useMoney } from './use-money.hook';

export function usePayoutAutomationUtils() {
  const { getFormattedMoney } = useMoney();

  const getLabelWithAccountInfo = useCallback(
    (automation: PayoutRequisitesAutomation) =>
      isNumber(automation.expectedBalance) ||
      isNumber(automation.accountInfo?.balance)
        ? `${automation.name} (${getFormattedMoney({
            value:
              automation.expectedBalance ||
              automation.accountInfo?.balance ||
              0,
            fiatCurrencyId: automation.balanceFiatCurrencyId,
            symbol: true,
          })})`
        : automation.name,
    [getFormattedMoney],
  );

  const getAutomationOptions = useCallback(
    (automations: PayoutRequisitesAutomation[]) =>
      map(automations, (automation) => ({
        label: getLabelWithAccountInfo(automation),
        value: automation.id,
      })),
    [getLabelWithAccountInfo],
  );

  return {
    getLabelWithAccountInfo,
    getAutomationOptions,
  };
}
